export interface UnreconciledDoseResolutionFilter {
  resolution?: string | string[] | null;
}

export const UNRECONCILED_DOSE_RESOLUTIONS = [
  "Unreconciled Dose: Multi-User",
  "Unreconciled Dose: Single-User"
];

export function addUnreconciledDoseResolutions(filter: UnreconciledDoseResolutionFilter | null | undefined): void {
  if (!filter) {
    return;
  }

  const resolution = getResolutionValues(filter);
  UNRECONCILED_DOSE_RESOLUTIONS.forEach((unreconciledDoseResolution) => {
    if (!resolution.includes(unreconciledDoseResolution)) {
      resolution.push(unreconciledDoseResolution);
    }
  });
  filter.resolution = resolution;
}

export function removeUnreconciledDoseResolutions(filter: UnreconciledDoseResolutionFilter | null | undefined): void {
  if (!filter) {
    return;
  }

  const resolution = getResolutionValues(filter)
    .filter((resolutionValue) => !UNRECONCILED_DOSE_RESOLUTIONS.includes(resolutionValue));

  if (resolution.length) {
    filter.resolution = resolution;
  } else {
    delete filter.resolution;
  }
}

export function hasUnreconciledDoseResolution(filter: UnreconciledDoseResolutionFilter | null | undefined): boolean {
  const resolution = getResolutionValues(filter);
  return UNRECONCILED_DOSE_RESOLUTIONS.some((unreconciledDoseResolution) =>
    resolution.includes(unreconciledDoseResolution)
  );
}

export function hasPartialUnreconciledDoseResolution(filter: UnreconciledDoseResolutionFilter | null | undefined): boolean {
  const resolution = getResolutionValues(filter);
  const unreconciledDoseResolutionCount = UNRECONCILED_DOSE_RESOLUTIONS.filter((unreconciledDoseResolution) =>
    resolution.includes(unreconciledDoseResolution)
  ).length;

  return unreconciledDoseResolutionCount > 0 &&
    unreconciledDoseResolutionCount < UNRECONCILED_DOSE_RESOLUTIONS.length;
}

function getResolutionValues(filter: UnreconciledDoseResolutionFilter | null | undefined): string[] {
  if (!filter || !filter.resolution) {
    return [];
  }

  return Array.isArray(filter.resolution)
    ? [...filter.resolution].filter((resolutionValue) => resolutionValue != null)
    : [filter.resolution];
}
